import { P as Pagination } from './swiper-pagination.js';
import { S as Swiper } from './swiper-index.js';
import './swiper-classes-to-selector.js';
import './swiper-create-element.js';
import './swiper-core.js';
import './swiper-a11y.js';

class HeroBanner extends HTMLElement {
  connectedCallback() {
    this.swiper = Swiper(this, {
      modules: [Pagination],
      spaceBetween: 0,
      slidesPerView: 1,
      autoplay: {
        delay: 200,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        bulletElement: 'button',
      },
    });
  }
}

customElements.define('hero-banner', HeroBanner);
